module.exports = __webpack_public_path__ + "img/icon_live.dc2ec67c.svg";